/**
 * Copyright © 2020 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { v4 } from 'uuid'

export const uniqueId = () => v4()
